import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'

import { Box } from 'swx-atomic-component-lib'
import OverflowMenu from './overflow-menu'
import AppLauncherIcon from 'calcite-ui-icons-react/AppLauncherIcon'

class NavigationAppBar extends Component {
  constructor (props) {
    super(props)
    this.classes = props.classes

    this.state = {
      open: false,
      openMoreDropdownMenu: false
    }

    this.openCloseMenu = this.openCloseMenu.bind(this)
  }

  openCloseMenu () {
    this.setState({ open: !this.state.open })
  }

  goTo (history, to) {
    history.push(to)
    this.openCloseMenu()
  }

  render () {
    return (
      <div>
        <Route render={({ history }) => (
          <Box h={48} w='100vw' display='flex' alignItems='center' justifyContent='space-between' customStyle='background-color:#fafafa;border-bottom:1px #bdbdbd solid;'>
            <Box renderAs='img' src='/logo-smarterwx.svg' pl={40} cursor='pointer' onClick={() => history.push('/')} />
            <Box pr={40} display='flex'>
              {this.props.user && this.props.user.role === 'SYSADMIN' && (
                <Box
                  display='flex'
                  flexDirection='column'
                  h={48}
                  justifyContent='space-between'
                  alignItems='center' pr={24}
                  onClick={() => this.goTo(history, '/applications')}
                  customStyle='justify-content: center;'
                >
                  {/* <Box renderAs={'img'} src={'/app-launcher-24-f.svg'} cursor='pointer' /> */}
                  <AppLauncherIcon size={19} filled style={{ cursor: 'pointer' }} />
                  {/* <Typography customStyle={styles.triggerPoint}>Applications</Typography> */}
                </Box>
              )}
              <Box display='flex' flexDirection='column' w={20} h={48} justifyContent='space-between' alignItems='center' pl={24} position='relative'>
                <OverflowMenu {...this.props} />
              </Box>
            </Box>
          </Box>
        )}
        />
      </div>
    )
  }
}

NavigationAppBar.defaultProps = {}

NavigationAppBar.propTypes = {
  classes: PropTypes.object.isRequired
}

export default NavigationAppBar
